module.exports = __webpack_public_path__ + "static/2-d3bcbc7be7584a4b5c2fd8cd427b697a.jpg";